import { render } from "./SvgIcon.vue?vue&type=template&id=ac412b3e&ts=true"
import script from "./SvgIcon.vue?vue&type=script&lang=ts"
export * from "./SvgIcon.vue?vue&type=script&lang=ts"

import "./SvgIcon.vue?vue&type=style&index=0&id=ac412b3e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__